<template>
  <div class="teaching-supply-elective">
    <PlatDataGridSite grid-id="PeTchElectiveSupply"
                      show-label></PlatDataGridSite>
  </div>
</template>

<script>
import PlatDataGridSite from '../../../wrapper/grid/PlatDataGridSite'
export default {
  name: 'TeachingSupplyElective',
  components: {
    PlatDataGridSite
  }
}
</script>

<style lang="scss">
  .teaching-supply-elective {
    height: 100%;
  }
</style>
